import { isAutomationClassGroupable } from 'src/app/conf/automation-class';
import { BoardUser, BoardUserNode, compareCodebase, isCodeTypeGroupable } from 'src/app/model/board-user';

export class BoardUsersTree {
	tmpBuListContentKeeper: any[];

	nodes: BoardUserNode[] = [];

	constructor(boardUsers: BoardUser[], automationClass: number) {
		if (!isAutomationClassGroupable(automationClass)) {
			const sortedUsers = []; // this.sortAndGroup(boardUsers);
			this.nodes = sortedUsers.map(u => new BoardUserNode(u));
		}
		this.groupByCodebase(boardUsers);
	}

	getNodes(): BoardUserNode[] {
		return this.nodes;
	}

	groupByCodebase(boardUsers: BoardUser[]) {
		if (boardUsers.length === 0) {
			return [];
		}
		for (const [i, elem] of boardUsers.entries()) {
			const newNode = new BoardUserNode(elem);
			newNode.data.Order = newNode.data.Position;
			if (!isCodeTypeGroupable(elem.Type)) {
				this.nodes = this.nodes.concat([newNode]);
				continue;
			} else {
				this.tryGroup(newNode);
			}
		}
		return [];
	}

	tryGroup(buNode: BoardUserNode) {
		const e = this.anyCompat(buNode.data);
		if (e) {
			e.children = e.children.concat([buNode]);
		} else {
			buNode.isCodeGroup = true;
			buNode.children = [new BoardUserNode(buNode.data)];
			buNode.data = Object.assign({}, buNode.data);
			buNode.data.Position = null;
			this.nodes = this.nodes.concat([buNode]);
		}
	}

	anyCompat(elem: BoardUser): BoardUserNode {
		for (const res of this.nodes) {
			if (elem.Type === res.data.Type && compareCodebase(elem, res.data)) {
				return res;
			}
		}
		return null;
	}
}
